import fetch from '../req'

export function getTotalStatics (query) {
  //获取客户数、新客数
  return fetch({
    url: '/index-static',
    method: 'get',
    data: query
  })
}

export function getMemberStatics (query) {
  //获取客户数、新客数
  return fetch({
    url: '/members/member-statistics',
    method: 'get',
    data: query
  })
}

export function getSaleStatics (query) {
  //获取销售额
  return fetch({
    url: '/salesperson/statistic/index',
    method: 'get',
    data: query
  })
}

export function getChannelList (query) {
  //获取销售额
  return fetch({
    url: '/salesperson/salesperson-member/channel-list',
    method: 'get',
    data: query
  })
}
